import f1 from './CAM_H_01.png';
import f2 from './CAM_H_02.png';
import f3 from './CAM_H_03.png';
import f4 from './CAM_H_04.png';
import f5 from './CAM_H_05.png';
import f6 from './CAM_H_07.png';
import f7 from './CAM_H_08.png';
import f8 from './GG_H_01.png';
import f9 from './GG_H_02.png';
import f10 from './GG_H_03.png';
import f11 from './GG_H_04.png';
import f12 from './GG_H_05.png';
import f13 from './GG_H_06.png';
import f14 from './GG_H_08.png';
import f15 from './RR_H_02.png';
import f16 from './RR_H_03.png';
import f17 from './RR_H_04.png';
import f18 from './RR_H_06.png';
import f19 from './RR_H_07.png';
import f20 from './RR_H_08.png';
import f21 from './SC_H_01.png';
import f22 from './SC_H_02.png';
import f23 from './SC_H_03.png';
import f24 from './SC_H_04.png';
import f25 from './SC_H_05.png';
import f26 from './SC_H_06.png';
import f27 from './SC_H_07.png';
import f28 from './SC_H_08.png';

let faces = [
  {'url':f1, 'num': 0},
  {'url':f2, 'num': 1},
  {'url':f3, 'num': 2},
  {'url':f4, 'num': 3},
  {'url':f5, 'num': 4},
  {'url':f6, 'num': 5},
  {'url':f7, 'num': 6},
  {'url':f8, 'num': 7},
  {'url':f9, 'num': 8},
  {'url':f10, 'num': 9},
  {'url':f11, 'num': 10},
  {'url':f12, 'num': 11},
  {'url':f13, 'num': 12},
  {'url':f14, 'num': 13},
  {'url':f15, 'num': 14},
  {'url':f16, 'num': 15},
  {'url':f17, 'num': 16},
  {'url':f18, 'num': 17},
  {'url':f19, 'num': 18},
  {'url':f20, 'num': 19},
  {'url':f21, 'num': 20},
  {'url':f22, 'num': 21},
  {'url':f23, 'num': 22},
  {'url':f24, 'num': 23},
  {'url':f25, 'num': 24},
  {'url':f26, 'num': 25},
  {'url':f27, 'num': 26},
  {'url':f28, 'num': 27},

];
export default faces;



// WEBPACK FOOTER //
// ./src/img/clothes/faces/faces.js